module.exports = __webpack_public_path__ + "static/media/NET.9a9efcbd.png";